<template>
  <div>
    <b-btn
      v-b-modal.reajusteValores
      variant="primary"
    >
      Reajuste de valores
    </b-btn>

    <b-modal
      id="reajusteValores"
      size="lg"
      hide-footer
    >
      <template #modal-header="{ close }">
        <h5 style="margin-top:0.5rem">
          Reajuste de valores
        </h5>
        <button
          size="sm"
          class="close servico-close"
          @click="close()"
        > <feather-icon
          icon="XIcon"
        /></button>
      </template>
      <p class="aviso-sn">
        As ações dessa tela impactam diretamente no cadastro de pacote!
      </p>
      <div
        class="px-1"
      >
        <validation-observer ref="validacaoReajuste">
          <b-row>
            <b-form-group
              label="Competência"
              class="col-md-6"
            >
              <validation-provider
                #default="{ errors }"
                rules="required"
                name="Competência"
              >
                <vue-monthly-picker
                  v-model="valueInner.competencia"
                  :input-class="'input-sm form-control w-100'"
                  :date-format="'MM/YYYY'"
                  :month-labels="['Jan', 'Fev', 'Mar','Abr','Maio','Jun','Jul','Ago','Set','Out','Nov','Dez']"
                  :alignment="'left'"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
            <b-form-group
              label="Tipo do aumento"
              class="col-md-6"
            >
              <b-select
                v-model="valueInner.tipoAumento"
                @change="converteValores"
              >
                <option
                  v-for="(opcao, $index) in tipoAumentoOpcoes"
                  :key="$index"
                  :value="opcao.value"
                >{{ opcao.text }}</option>
              </b-select>
            </b-form-group>
          </b-row>
          <b-row>
            <b-form-group
              class="col-md-6"
              :label="!mostrarValorCheio ? 'Valor RCC' : ''"
            >
              <dinheiro-input
                v-if="mostrarValorCheio"
                v-model="valueInner.valorRCC"
                :label="'Valor RCC'"
                require
                :options="{ currency: 'BRL', precision: 2, hideNegligibleDecimalDigitsOnFocus: false, autoDecimalDigits: false}"
              />
              <validation-provider
                v-else
                #default="{ errors }"
                rules="required"
                name="Valor RCC"
              >
                <b-form-input
                  v-model="valueInner.valorRCC"
                  :state="errors.length > 0 ? false:null"
                  @blur="formataPorcentagemRCC"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
            <b-form-group
              class="col-md-6"
              :label="!mostrarValorCheio ? 'Valor Auditar' : ''"
            >
              <dinheiro-input
                v-if="mostrarValorCheio"
                v-model="valueInner.valorAuditar"
                :label="'Valor Auditar'"
                require
                :options="{ currency: 'BRL', precision: 2, hideNegligibleDecimalDigitsOnFocus: false, autoDecimalDigits: false}"
              />
              <validation-provider
                v-else
                #default="{ errors }"
                rules="required"
                name="Valor Auditar"
              >
                <b-form-input
                  v-model="valueInner.valorAuditar"
                  :state="errors.length > 0 ? false:null"
                  @blur="formataPorcentagemAuditar"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-row>
        </validation-observer>
        <b-row
          align-h="end"
          class="mb-1"
        >
          <b-col cols="auto">
            <b-btn
              class="btn btn-success btn-sm"
              variant="none"
              @click="verificaVinculo()"
            >
              Aplicar
            </b-btn>
          </b-col>
        </b-row>
      </div>

      <!-- Históricos -->
      <div class="px-1">
        <hr style="border-top: 1px solid #a3a4a66b !important; margin: 0.5rem 0">
        <b-row
          class="mb-1 mt-2"
          style="justify-content: space-between;"
        >
          <b-col
            cols="3"
            class="ml-50"
          >
            <span class="titulo-historico">Histórico</span>
          </b-col>
          <b-col
            cols="2"
          >
            <b-btn
              size="sm"
              class="btn-historico"
              style="float: right"
              variant="primary"
              @click="mostrarHistorico"
            >{{ !mostrar.historico ? 'Mostrar' : 'Esconder' }}</b-btn>
          </b-col>
        </b-row>
        <div
          v-if="mostrar.historico"
          class="px-1"
        >
          <div
            v-for="(historico, $index) in historicos"
            :key="$index"
            class="mb-1 d-inline-flex"
          >
            <div>
              <b>{{ historico.usuarioReajuste }}</b>
              &nbsp;{{ historico.descricao }}
              <div
                class="detail mt-50"
                style="font-size: 12.5px;"
              ><b>{{ formatDate(historico.dataReajuste, { month: 'numeric', day: 'numeric', year: 'numeric', hour: 'numeric', minute:'numeric' }) }}</b></div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<style lang="scss">
.servico-close{
    margin: 0 !important;
    padding: 0 0.62rem 0.2rem 0.62rem !important;
}
.titulo-historico {
  font-size: 18px !important;
}

.aviso-sn{
  text-align: center;
  background-color: lightgoldenrodyellow;
  padding: 0.5rem;
  margin-bottom: 1rem;
}

.btn-historico {
  padding: 0.3rem 0.5rem;
}
</style>

<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import {
  required,
} from '@validations'
import VueMonthlyPicker from 'vue-monthly-picker'
import { formatDate } from '@core/utils/filter'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import moment from 'moment'
import api from '@/app-modulo/comuns/servico/shared/services/api'

export default {
  name: 'ReajusteModal',
  components: {
    VueMonthlyPicker,
    DinheiroInput: () => import('@/shared/components/dinheiro-input/DinheiroInput.vue'),
    ValidationObserver,
    ValidationProvider,
  },
  props: {
    value: {
      type: Object,
      default: () => { },
    },
    servicoId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      required,
      formatDate,
      valueInner: {
        tipoAumento: 'valorcheio',
        valorRCC: 0,
        valorAuditar: 0,
        competencia: moment(moment(), 'YYYY/MM'),
      },
      tipoAumentoOpcoes: [
        { value: 'percentual', text: 'Percentual de aumento' },
        { value: 'valorcheio', text: 'Valor total' },
      ],
      mostrar: {
        cadastro: true,
        historico: false,
      },
      historicos: null,
      mostrarValorCheio: true,
    }
  },
  watch: {
    value(value, oldValue) {
      if (value && value !== oldValue) {
        this.valueInner = value
      }
    },
  },
  created() {
    if (this.value) {
      this.valueInner = this.value
    }
  },
  methods: {
    mostrarHistorico() {
      this.mostrar.historico = !this.mostrar.historico
      if (this.mostrar.historico && this.historicos === null) {
        api.getHistoricosReajuste(this.servicoId)
          .then(payload => {
            this.historicos = payload.data
          })
      }
    },
    converteValores() {
      this.removeCaracteresValores()
      if (this.valueInner.tipoAumento === 'percentual') {
        this.formataPorcentagemRCC()
        this.formataPorcentagemAuditar()
        this.mostrarValorCheio = false
      } else {
        this.mostrarValorCheio = true
      }
    },
    removeCaracteresValores() {
      this.valueInner.valorRCC = parseFloat(this.valueInner.valorRCC, 10)
      this.valueInner.valorAuditar = parseFloat(this.valueInner.valorAuditar, 10)
    },
    validaCampos() {
      this.$refs.validacaoReajuste.validate()
        .then(success => {
          if (success) {
            const compFormatada = this.getCompetenciaFormatada(moment(this.valueInner.competencia, 'YYYY/MM').toISOString())
            const compAtualFormatada = this.getCompetenciaFormatada(moment(moment(), 'YYYY/MM').toISOString())

            if (moment(compAtualFormatada, 'MM/YYYY').isAfter(moment(compFormatada, 'MM/YYYY'))) {
              this.mostraMensagem('danger', 'Não é possível selecionar uma competência anterior à atual')
            } else if (parseFloat(this.valueInner.valorRCC, 10) > 0 || parseFloat(this.valueInner.valorAuditar, 10) > 0) {
              this.$bvModal.hide('reajusteValores')
            } else {
              this.mostraMensagem('danger', 'Pelo menos um valor deve ser preenchido')
            }
          } else {
            this.mostraMensagem('danger', 'Preencha os campos corretamente')
          }
        })
    },
    formataPorcentagemAuditar() {
      const valorAuditarFormatado = parseFloat(this.valueInner.valorAuditar, 10)
      this.valueInner.valorAuditar = !valorAuditarFormatado ? `${0}%` : `${valorAuditarFormatado}%`
    },
    formataPorcentagemRCC() {
      const valorRCCFormatado = parseFloat(this.valueInner.valorRCC, 10)
      this.valueInner.valorRCC = !valorRCCFormatado ? `${0}%` : `${valorRCCFormatado}%`
    },
    mostraMensagem(variante, mensagem) {
      if (variante === 'danger') {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: mensagem,
            icon: 'AlertCircleIcon',
            variant: 'danger',
          },
        })
      } else if (variante === 'success') {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: mensagem,
            icon: 'CheckCircleIcon',
            variant: 'success',
          },
        })
      }
    },
    getCompetenciaFormatada(comp) {
      return `${comp.substr(comp.indexOf('-') + 1, 2)}/${comp.substr(0, comp.indexOf('-'))}`
    },
    verificaVinculo() {
      this.$swal({
        text: 'Atenção: Caso esse serviço esteja vinculado em pacotes, ao realizar o reajuste de valores, será alterado o valor desse serviço nesse cadastro e nos pacotes vinculados. As propostas que já estiverem vinculadas com esse serviço não sofrem alteração, somente novas propostas cadastradas. Deseja continuar?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sim',
        cancelButtonText: 'Não',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-danger ml-1',
        },
      })
        .then(result => {
          if (result.value) {
            this.validaCampos()
          }
        })
    },
  },
}
</script>
